import {FormControl, TextField} from "@mui/material";
import React, {useEffect} from "react";
import style from "../../assets/css/global-fields.module.scss";

const GlobalTextField = ({
  placeH, // Placeholder text (Mandatory)
  type = "text", // Default type is 'text'
  onChange, // Function to handle change event (Mandatory)
  onBlur, // Function to handle blur event (Mandatory)
  value, // Value to bind to the input (Mandatory)
  id, // id of the input (Mandatory)
  inputRef, // Optional: Reference for the input
  label, // Optional: Label for the input
  error, // Optional: Error prop to show if there's a validation error
  helperText, // Optional: Helper text to show error messages
  name, // Optional: Name for the input field (mandatory in Formik)
  fullWidth = true,
  disabled = false, // Optional: Default to full width
  cssClass,
}) => {
  // Check if error and helperText props are passed and set defaults if not
  const hasError = error !== undefined ? error : false;
  const errorText = helperText || "";
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Allow only numeric values (prevent alphabets and special characters)
    if (type === "number") {
      const numericValue = inputValue.replace(/[^0-9]/g, ""); // Remove invalid characters
      onChange({
        target: {
          name: e.target.name,
          value: numericValue,
        },
      });
    } else {
      onChange(e);
    }
  };

  useEffect(() => {
    // Select all inputs inside the wrapper class TextFieldPosiRela
    const textFieldInputs = document.querySelectorAll(
      ".TextFieldPosiRela input"
    );

    textFieldInputs.forEach((input, inpuId) => {
      // Add or update aria-label as needed
      input.setAttribute("aria-label", "text-field" + inpuId);
    });
  }, []);

  return (
    <div className={style.proposalTextField}>
      {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
      {/* <label style={{ opacity: '0', position: 'absolute', zIndex: '-99px', top: '0', left: '0' }} htmlFor={name}>{name}</label> */}

      <FormControl fullWidth={fullWidth} className="TextFieldPosiRela">
        <TextField
          id={id} // Use the provided id
          aria-label="text"
          type={type} // Dynamic input type
          variant="outlined"
          placeholder={placeH} // Set the placeholder dynamically
          // value={type === "text" ? value || "" : value} // Controlled input value
          value={
            value ?? (type === "text" ? "" : type === "number" ? "" : value)
          }
          onChange={handleInputChange} // onChange handler for input
          onBlur={onBlur} // onBlur handler for input
          inputRef={inputRef} // Optional ref for the input
          label={label} // Optional label prop
          error={hasError} // Show error styling if true
          helperText={errorText} // Show error message below the input if any
          name={name} // Formik's name attribute (optional)
          disabled={disabled}
          className={cssClass || "  "}
          slotProps={{
            input: {
              inputMode: type === "number" ? "numeric" : "text", // Numeric keyboard for mobile
              pattern: type === "number" ? "[0-9]*" : undefined, // Enforce numeric pattern
            },
          }}
        />
      </FormControl>
    </div>
  );
};

export default GlobalTextField;
